import { createI18nHook, createTranslatedI18nHook, createTranslateHook, createTranslateTextsHook } from '@hilma/netina2all';

import { I18n } from '../types';

export const useTranslatedI18n = createTranslatedI18nHook<I18n>();
export const useI18n = createI18nHook<I18n>();
export const useTranslate = createTranslateHook<I18n>();
export const useTranslateTexts = createTranslateTextsHook<I18n>();
